import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@src/api/config";
import {
  O360Membership,
  o360Coverage
} from "@src/components/certs/o360/memberships/o360.types";

type O360MembershipsState = {
  memberships: O360Membership[];
  loading: boolean;
};

export const getO360Memberships = createAsyncThunk<
  { data: any },
  { client_id?: number | string | null }
>("o360/memberships", async ({ client_id } = {}, { getState }) => {
  const state = getState() as {
    products?: { productSelected?: { value?: string | number } };
    businessLines?: { businessLineSelected?: { id?: string | number } };
  };
  const product = state.products?.productSelected?.value ?? "";
  const business_line = state.businessLines?.businessLineSelected?.id ?? "";
  const params: Record<string, any> = { product, business_line };
  if (client_id !== null) params.client_id = client_id;
  const response = await api.get("/api/memberships", { params });
  return { data: response.data };
});

const normalizeSkus = (skus: any): o360Coverage[] => {
  if (!Array.isArray(skus)) return [];
  if (typeof skus.flat === "function") {
    return skus.flat();
  }
  return skus.reduce((acc: o360Coverage[], item: any) => {
    if (Array.isArray(item)) return acc.concat(item);
    acc.push(item);
    return acc;
  }, []);
};

const normalizeMemberships = (payload: any): O360Membership[] => {
  let items: any[] = [];
  if (Array.isArray(payload?.data?.data)) {
    items = payload.data.data;
  } else if (Array.isArray(payload?.data)) {
    items = payload.data;
  } else if (Array.isArray(payload)) {
    items = payload;
  }

  return items.map((item) => {
    const skus = normalizeSkus(item?.skus);
    const coverages = Array.isArray(item?.coverages) ? item.coverages : skus;
    return {
      ...item,
      coverages,
      skus
    } as O360Membership;
  });
};

const initialState: O360MembershipsState = {
  memberships: [],
  loading: false
};

const o360MembershipsSlice = createSlice({
  name: "o360Memberships",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getO360Memberships.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getO360Memberships.fulfilled, (state, action) => {
      state.memberships = normalizeMemberships(action.payload.data);
      state.loading = false;
    });
    builder.addCase(getO360Memberships.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default o360MembershipsSlice.reducer;
